import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Faq.css';

const FaqItem = ({ question, answer, isOpen, toggle }) => {
  return (
    <div className={`legal-faq-item ${isOpen ? 'active' : ''}`}>
      <button className="legal-faq-question" onClick={toggle}>
        <span>{question}</span>
        <motion.span 
          className="legal-faq-icon"
          animate={{ rotate: isOpen ? 180 : 0 }}
        >
          ▼
        </motion.span>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="legal-faq-answer-wrapper"
          >
            <div className="legal-faq-answer">
              <p>{answer}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Is Dhanushdhari safe to use?",
      answer: "Yes, we utilize bank-grade AES-256 encryption. All documents are processed within secure environments and we never store your data without explicit permission."
    },
    {
      question: "Can I cancel my subscription anytime?",
      answer: "Absolutely. You can manage your billing through your dashboard and cancel at any time with no hidden fees or exit penalties."
    },
    {
      question: "Do you offer professional support?",
      answer: "Yes, our team provides 24/7 live chat and priority email support for all our enterprise and professional plan users."
    },
  ];

  return (
    <section id="faq" className="legal-faq-section">
      <div className="legal-faq-container">
        <motion.div 
          className="legal-faq-header"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="legal-faq-badge">Support</span>
          <h2 className="legal-faq-title">Frequently Asked Questions</h2>
        </motion.div>

        <div className="legal-faq-list">
          {faqs.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={activeIndex === index}
              toggle={() => setActiveIndex(activeIndex === index ? null : index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faq;